window.addEventListener('DOMContentLoaded', () => {
	const selector = document.getElementById('insim-block-courses-select');

	if (!selector) {
        console.warn('select list not found')
		return;
    }

	selector.addEventListener('change', e => {
		if (e.target.value)
			window.location.href = e.target.value;
	});
});
